import { useState } from "react";
import DialogFormPanel from "../../../../../../shared/components/panel/DialogFormPanel";
import CreateObjectiveTrackerForm from "./CreateObjectiveTrackerForm";
import CreateButtonTrigger from "../../../../../../shared/components/button/CreateButtonTrigger";
import useAuthentication from "../../../../../../hooks/useAuthentication";
import { useTranslation } from "react-i18next";

const CreateObjectiveTrackerDialog = ({ onSubmitHandler, clients }) => {
  const auth = useAuthentication();
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const onSubmit = (formValues) => {
    const values = { ...formValues, createdBy: auth.userLogged().fullname };
    onSubmitHandler(values);
    setIsOpen(false);
  };

  return (
    <DialogFormPanel
      trigger={<CreateButtonTrigger />}
      title={t("objectivesTracker.createForm.title")}
      description={t("objectivesTracker.createForm.description")}
      content={
        <CreateObjectiveTrackerForm
          onSubmitHandler={onSubmit}
          clients={clients}
        />
      }
      isOpen={isOpen}
      setIsOpen={setIsOpen}
    />
  );
};

export default CreateObjectiveTrackerDialog;
